import * as Sentry from "@sentry/react";
import { I18n as I18nClass } from "i18n-js";
import { invariant } from "./invariant.ts";

const translations: Record<string, object> = {};

const localeFilesContext = require.context(
  "../../../../config/locales/",
  false,
);

for (const key of localeFilesContext.keys()) {
  const module = localeFilesContext(key);

  const language = key.match(
    /\.\/((countries|flowcase)\.)?(?<code>[a-z]{2})\.yml/,
  )?.groups?.code;

  invariant(language, `Cannot extract language from ${key}`);

  translations[language] = {
    ...translations[language],
    ...module.default[language],
  };
}

// Rails attaches user locale information to `window.cvpI18n`
declare global {
  var cvpI18n: {
    locale: string;
    defaultLocale: string;
  };
}

const i18n = new I18nClass(translations, {
  locale: window.cvpI18n.locale,
  defaultLocale: window.cvpI18n.defaultLocale,
});

const warnedMissingTranslations = new Set<string>();

i18n.missingTranslation.register("sentry", (i18n, i18nScope, options) => {
  const scopeString =
    typeof i18nScope === "string"
      ? i18nScope
      : Array.isArray(i18nScope)
        ? i18nScope.join(i18n.defaultSeparator)
        : String(i18nScope);

  if (!warnedMissingTranslations.has(scopeString)) {
    Sentry.withScope((scope) => {
      scope.setLevel("warning");
      scope.setExtra("scope", i18nScope);
      scope.captureException(
        new Error(`Missing translation: "${scopeString}"`),
      );
    });

    warnedMissingTranslations.add(scopeString);
  }

  return i18n.missingTranslation.get(i18nScope, {
    ...options,
    missingBehavior: "message",
  });
});
i18n.missingBehavior = "sentry";

export const I18n = i18n;
